import { create } from 'zustand';
export const useInputModeStore = create((set, get) => ({
    inputMode: {
        from: 'amount',
        to: 'amount',
    },
    setInputMode: (formType, mode) => set((state) => ({
        inputMode: {
            ...state.inputMode,
            [formType]: mode,
        },
    })),
    toggleInputMode: (formType) => {
        const currentMode = get().inputMode[formType];
        const newMode = currentMode === 'amount' ? 'price' : 'amount';
        get().setInputMode(formType, newMode);
    },
}));
//# sourceMappingURL=useInputModeStore.js.map